var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.48 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.24,7.16,22.88,1.51a.44.44,0,0,0-.41-.27.44.44,0,0,0-.17,0L18.88,2.71l2.78,2.17a1.84,1.84,0,0,1,.69,1.23,1.86,1.86,0,0,1-.19,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.61,4.63a1.87,1.87,0,0,1,1,1,1.84,1.84,0,0,1,0,1.41l0,.1h4.89l.44-.56A.44.44,0,0,0,20.79,6L13.25.09a.44.44,0,0,0-.62.08L10.52,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.06,5.93,5.26,2.16a.44.44,0,0,0-.58.23l-2,4.78H14l.28-.66a.44.44,0,0,0-.23-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.16,9.48a1.28,1.28,0,0,0-1-.44H1.29A1.29,1.29,0,0,0,0,10.51L1.52,20.9A1.29,1.29,0,0,0,2.79,22h21.9A1.29,1.29,0,0,0,26,20.9l1.51-10.39A1.29,1.29,0,0,0,27.16,9.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContents);
export default __webpack_public_path__ + "static/media/icon-contents.4bcacb5c97b93105ac57e4035f14ea14.svg";
export { ForwardRef as ReactComponent };